"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.____Declaration = void 0;
const __1 = require("../");
class ____Declaration extends __1.EL {
    tag = "____Declaration";
    get isControl() { return true; }
    attr;
    children;
    valueCache = null;
    get value() {
        if (this.valueCache !== null && this.valueCache[0] === this.attr.value) {
            return this.valueCache[1];
        }
        else {
            const value = (this.attr.value !== undefined) ? JSON.parse(this.attr.value) : null;
            this.valueCache = [this.attr.value, value];
            return value;
        }
    }
    scopeCache = null;
    get scope() {
        if (this.scopeCache !== null && this.scopeCache[0] === this.attr.scope) {
            return this.scopeCache[1];
        }
        else {
            const scope = JSON.parse(this.attr.scope);
            this.scopeCache = [this.attr.scope, scope];
            return scope;
        }
    }
    nameSentenceTextRangeCache = null;
    get nameSentenceTextRange() {
        if (this.nameSentenceTextRangeCache !== null && this.nameSentenceTextRangeCache[0] === this.attr.nameSentenceTextRange) {
            return this.nameSentenceTextRangeCache[1];
        }
        else {
            const nameSentenceTextRange = JSON.parse(this.attr.nameSentenceTextRange);
            this.nameSentenceTextRangeCache = [this.attr.nameSentenceTextRange, nameSentenceTextRange];
            return nameSentenceTextRange;
        }
    }
    set nameSentenceTextRange(value) {
        this.attr.nameSentenceTextRange = JSON.stringify(value);
        this.nameSentenceTextRangeCache = [this.attr.nameSentenceTextRange, value];
    }
    constructor(options) {
        super("____Declaration", {}, [], options.range);
        const { declarationID: id, type, name, value, scope, nameSentenceTextRange, children } = options;
        this.attr = {
            declarationID: id,
            type,
            name,
            scope: JSON.stringify(scope),
            nameSentenceTextRange: JSON.stringify(nameSentenceTextRange),
        };
        if (value !== null)
            this.attr.value = JSON.stringify(value);
        this.children = children;
    }
}
exports.____Declaration = ____Declaration;
//# sourceMappingURL=declaration.js.map